import { useEffect, useRef } from 'react';
import { Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

const PrintReceipt = ({ pdfUrl }) => {
    const iframeRef = useRef();

    const handlePrint = async () => {
        const res = await fetch(pdfUrl, { cache: 'no-store' });
        const blob = await res.blob();
        const blobUrl = URL.createObjectURL(blob);

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobUrl;
        iframe.allow = 'fullscreen'; // optional
        document.body.appendChild(iframe);

        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();

            // Optional aufräumen
            setTimeout(() => {
                document.body.removeChild(iframe);
                URL.revokeObjectURL(blobUrl);
            }, 2000);
        };
    };

    return (
        <Button  
        startIcon={<PrintIcon />}
        size='small' variant="outlined" onClick={handlePrint}>
            Bon
        </Button>
    );
};

export default PrintReceipt;
